export const PROGRAM_SLIDE_REGISTRY_NAME_MAX_LENGTH = 5;
export const PROGRAM_SLIDE_REGISTERED_PAGE_MAX_COUNT = 10;
export const PROGRAM_SLIDE_REGISTERED_LAYOUT_MAX_COUNT = 20;

export function limitProgramSlideRegistryNameDraft(raw: string): string {
  return Array.from(raw).slice(0, PROGRAM_SLIDE_REGISTRY_NAME_MAX_LENGTH).join('');
}

export function normalizeProgramSlideRegistryName(raw: unknown, fallback: string): string {
  const trimmed = String(raw ?? '').trim();
  const base = trimmed || fallback;
  return limitProgramSlideRegistryNameDraft(base);
}

export function programSlideRegistryMaxCount(isLayoutRegistryMode: boolean): number {
  return isLayoutRegistryMode
    ? PROGRAM_SLIDE_REGISTERED_LAYOUT_MAX_COUNT
    : PROGRAM_SLIDE_REGISTERED_PAGE_MAX_COUNT;
}

export function programSlideRegistryFallbackName(index: number): string {
  return String(index + 1);
}
